// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"5bae0ce5","350":"99e1547e","360":"5464538a","445":"5a9d75b4","453":"e67b519e","455":"766972e6","536":"5a6053b5","559":"6d6ba85b","722":"3ae92761","827":"c1aee1ec","944":"2564777f","977":"2626d0aa","994":"b72dc2fc"}[chunkId] + ".chunk.js";
};